import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { getBatchTestClaimListActions } from "@/App/actions";
import { BatchTestClaimTypes, GeneralTypes } from "@/types";
import { getTestClaimListResults } from "@/App/actions/appActions/transmissions/batchTest/list";

function formatData(
  data: Array<{
    batch_test_file: BatchTestClaimTypes.BatchTestClaim;
  }>,
): Array<BatchTestClaimTypes.BatchTestClaim> {
  return data.map((val) => {
    return {
      created_at: val.batch_test_file.created_at,
      id: val.batch_test_file.id,
      original_name: val.batch_test_file.original_name,
      status: val.batch_test_file.status,
      parent_batch_test_claims_file_id: val?.batch_test_file?.parent_batch_test_claims_file_id,
      total_children: val?.batch_test_file?.total_children,
      children_completed: val?.batch_test_file?.children_completed,
      total_rows: val?.batch_test_file?.total_rows,
      rows_processed: val?.batch_test_file?.rows_processed,
      is_bundled: val?.batch_test_file?.is_bundled,
      display_status: val?.batch_test_file?.display_status,
    };
  });
}

function* getBatchTestClaimList(payload: { queryOptions: GeneralTypes.QueryOptions }): Generator {
  return yield apiService({
    url: "/transmission/batch_test/list",
    method: "POST",
    data: payload.queryOptions,
  });
}

export function* getBatchTestClaimListWorker(action: ReturnType<typeof getBatchTestClaimListActions.getTestClaimList>): SagaIterator {
  const { payload } = action;
  const { showPageAlert } = PageAlert;

  try {
    const { results, result_count } = yield call(getBatchTestClaimList, payload);
    const formattedData = formatData(results);

    yield put(
      getTestClaimListResults({
        results: formattedData,
        result_count: result_count,
      }),
    );
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message }));
  }
}

export default function* getBatchTestClaimWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM_LIST, getBatchTestClaimListWorker);
}
